import makeStyles from '@mui/styles/makeStyles';

export const usePageActionsStyles = makeStyles((theme) => ({
  buttonSection: {
    position: 'relative',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    columnGap: '0.75rem',
    justifyContent: 'flex-end',
  },
  leftButtonSection: {},
  iconSection: {
    display: 'flex',
  },
  buttonOutlined: {
    border: `1px solid ${theme.palette.baseColors.deepSeaNavy.c100}`,
    color: theme.palette.baseColors.deepSeaNavy.c100,
    '&:hover': {
      color: theme.palette.baseColors.deepSeaNavy.c75,
      borderColor: theme.palette.baseColors.deepSeaNavy.c75,
    },
  },
  iconButton: {
    color: theme.palette.baseColors.deepSeaNavy.c100,
  },
  pageActions: {
    display: 'flex',
    columnGap: 'inherit',
  },
  pageActionsWithSecondary: {
    position: 'relative',
  },
  pageActionsVerticalLine: {
    position: 'relative',
    width: '1px',
    flexGrow: 1,
    background: theme.palette.baseColors.black.c12,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
}));
